// Small charts — Project Approval's two bar charts (ApprovalCharts.jsx), the designer's donut on Home
// (DesignerDonut.jsx) and the Sample Tracker's Dashboard tab (21_DevDashboard.jsx) — in the portal's four
// languages (2026-10-21). HomeWorkload.jsx already reads `home.workload.*` and needs nothing here.
const en = {
  approval: {
    approvedBy: 'Approved by {{name}}',
    theCeo: 'the CEO',
    ownDecisions: 'his own decisions · {{n}} projects',
    barTitle: '{{label}}: {{n}} — click to list them below',
    teamApproved: '{{team}} · approved',
    teamState: '{{team}} · {{state}}',
    runningTitle: 'Running · completed · dropped',
    ofWhatHeApproved: 'of what he approved · {{n}}',
    running: 'Running',
    completed: 'Completed',
    dropped: 'Dropped',
  },
  donut: {
    title: 'Sample review',
    empty: 'No samples were sent to you in the last {{days}} days.',
    lastDays: 'last {{days}} days',
    everyone: 'everyone',
    aria: '{{done}} of {{received}} done in the last {{days}} days',
    processed: 'processed',
    openList: 'Open this list in the Sample Tracker',
    received: 'Received',
    done: 'Done',
    inReview: 'In review',
    waiting: 'Waiting 2 weeks+',
  },
  dev: {
    rounds: '{{n}} rounds',
    attrHevn: 'HEVN (caused)',
    attrHinc: 'HINC (caused)',
    attrExt: 'External',
    loadError: 'Error loading dashboard: {{error}}',
    loadFailed: 'Failed to load dashboard',
    days: '{{n}}d',
    unitSamplesByBase: 'samples by Base ID',
  },
};

const ko = {
  approval: {
    approvedBy: '{{name}} 승인',
    theCeo: 'CEO',
    ownDecisions: '본인 결정 · 프로젝트 {{n}}건',
    barTitle: '{{label}}: {{n}} — 클릭하면 아래에 목록이 표시됩니다',
    teamApproved: '{{team}} · 승인',
    teamState: '{{team}} · {{state}}',
    runningTitle: '진행 · 완료 · 드롭',
    ofWhatHeApproved: '승인한 프로젝트 중 · {{n}}',
    running: '진행',
    completed: '완료',
    dropped: '드롭',
  },
  donut: {
    title: '샘플 검토 현황',
    empty: '최근 {{days}}일 동안 검토할 샘플이 없습니다.',
    lastDays: '최근 {{days}}일',
    everyone: '전체',
    aria: '최근 {{days}}일 {{received}}건 중 {{done}}건 완료',
    processed: '처리율',
    openList: '샘플 트래커에서 보기',
    received: '접수',
    done: '완료',
    inReview: '검토 중',
    waiting: '2주 이상 대기',
  },
  dev: {
    rounds: '{{n}}개 라운드',
    attrHevn: 'HEVN (원인)',
    attrHinc: 'HINC (원인)',
    attrExt: '외부',
    loadError: '대시보드를 불러오지 못했습니다: {{error}}',
    loadFailed: '대시보드를 불러오지 못했습니다',
    days: '{{n}}일',
    unitSamplesByBase: 'Base ID 기준 샘플',
  },
};

const vi = {
  approval: {
    approvedBy: 'Do {{name}} duyệt',
    theCeo: 'CEO',
    ownDecisions: 'quyết định của chính anh ấy · {{n}} dự án',
    barTitle: '{{label}}: {{n}} — bấm để liệt kê bên dưới',
    teamApproved: '{{team}} · đã duyệt',
    teamState: '{{team}} · {{state}}',
    runningTitle: 'Đang chạy · hoàn thành · đã hủy',
    ofWhatHeApproved: 'trong số dự án anh ấy duyệt · {{n}}',
    running: 'Đang chạy',
    completed: 'Hoàn thành',
    dropped: 'Đã hủy',
  },
  donut: {
    title: 'Duyệt mẫu',
    empty: 'Không có mẫu nào được gửi cho bạn trong {{days}} ngày qua.',
    lastDays: '{{days}} ngày qua',
    everyone: 'mọi người',
    aria: '{{done}} trên {{received}} đã xong trong {{days}} ngày qua',
    processed: 'đã xử lý',
    openList: 'Mở danh sách này trong Theo dõi mẫu',
    received: 'Đã nhận',
    done: 'Xong',
    inReview: 'Đang duyệt',
    waiting: 'Chờ trên 2 tuần',
  },
  dev: {
    rounds: '{{n}} vòng',
    attrHevn: 'HEVN (gây ra)',
    attrHinc: 'HINC (gây ra)',
    attrExt: 'Bên ngoài',
    loadError: 'Lỗi tải dashboard: {{error}}',
    loadFailed: 'Không tải được dashboard',
    days: '{{n}} ngày',
    unitSamplesByBase: 'mẫu theo Base ID',
  },
};

const zh = {
  approval: {
    approvedBy: '{{name}} 批准',
    theCeo: 'CEO',
    ownDecisions: '本人的决定 · {{n}} 个项目',
    barTitle: '{{label}}：{{n}} — 点击在下方列出',
    teamApproved: '{{team}} · 已批准',
    teamState: '{{team}} · {{state}}',
    runningTitle: '进行中 · 已完成 · 已放弃',
    ofWhatHeApproved: '其批准的项目 · {{n}}',
    running: '进行中',
    completed: '已完成',
    dropped: '已放弃',
  },
  donut: {
    title: '样品评审',
    empty: '最近 {{days}} 天内没有发送给您的样品。',
    lastDays: '最近 {{days}} 天',
    everyone: '全部',
    aria: '最近 {{days}} 天 {{received}} 件中已完成 {{done}} 件',
    processed: '处理率',
    openList: '在样品跟踪中打开此列表',
    received: '已接收',
    done: '已完成',
    inReview: '评审中',
    waiting: '等待 2 周以上',
  },
  dev: {
    rounds: '{{n}} 轮',
    attrHevn: 'HEVN（造成）',
    attrHinc: 'HINC（造成）',
    attrExt: '外部',
    loadError: '仪表板加载出错：{{error}}',
    loadFailed: '仪表板加载失败',
    days: '{{n}} 天',
    unitSamplesByBase: '按 Base ID 计的样品',
  },
};

const dictionary = { ns: 'xCharts', en, ko, vi, zh };

export default dictionary;
